<template>
  <div class="container" id="coach_detail_outer" v-if="item != null">
    <h3 style="margin-top: 50px;">认证教练员</h3>
    <div class="referee-information-outer">
      <a class="return-to-list" href="javascript:void(0)" v-on:click="goBackToList"><<返回列表</a>
      <div class="referee-information">
        <div class="left-view">
          <div class="img-view">
            <el-image v-if="item.coach.photo != null && item.coach.photo.length > 0" class="user-image" fit="contain" :src="item.coach.photo" :preview-src-list="[item.coach.photo]" />
            <el-image v-else class="user-image" fit="contain" :src="defaultHeaderImage" />
            <div v-show="isChecked" :class="['status-label', 'active']">认证有效期内</div>
          </div>
        </div>
        <div class="right-view">
          <div class="nickname">{{item.coach.name}}</div>
          <div class="sub-row-view">
            <div><strong>性别：</strong>{{item.coach.sex}}</div>
            <div>
              <strong>教练员资质：</strong>
              <div style="margin-top: 2px;" v-for="(certItem, index) in item.certificates" :key="'cert-item_' + index">
                <span>{{certItem.name}} <span style="margin-left: 15px;">{{certItem.level}}</span></span>
              </div>
            </div>
            <div><strong>认证有效期：</strong><br>{{ coachValidDateStr }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import userDefaultGoldIcon from '../assets/shl_personal_head_portrait_gold_default.png'
  import userDefaultRedIcon from '../assets/shl_personal_head_portrait_red_default.png';
export default {
  name: "CoachDetailPage",
  data() {
    return {
      item: null,
    }
  },
  computed: {
    httpManager() {
      return this.$store.state.http;
    },
    coachId() {
      return this.$route.params.coachId;
    },

    coachBeginDate() {
      let item = this.item;
      if (item == null) {
        return null;
      }
      let auditTime = item.coach.auditTime;
      if (auditTime == null || auditTime == '') {
        return null;
      }
      let date = this.$moment(auditTime);
      return date;
    },

    coachValidDate() {
      let item = this.item;
      if (item == null) {
        return null;
      }
      let auditTime = item.coach.auditTime;
      if (auditTime == null || auditTime == '') {
        return null;
      }
      let date = this.$moment(auditTime);
      date = date.add(2, 'years');
      return date;
    },
    coachValidDateStr() {
      let beginDate = this.coachBeginDate;
      let endDate = this.coachValidDate;
      if (beginDate == null || endDate == null) {
        return '';
      }
      return beginDate.format('yyyy-MM-DD') + ' 至 ' + endDate.format('yyyy-MM-DD');
    },
    isChecked() {
      let item = this.item;
      if (item == null) {
        return false;
      }
      let coach = item.coach;
      let validDate = this.coachValidDate;
      let now = this.$moment();
      if (validDate - now > 0) { // 未过期
        return true;
      }
      return false;
    },

    defaultHeaderImage() {
      return this.isChecked ? userDefaultGoldIcon : userDefaultRedIcon;
    }
  },
  mounted() {
    this.loadData();
  },
  methods: {

    getCertificateAllNameString(item) {
      // item.certificates[0].name
      let certificates = item.certificates;
      if (certificates == null || certificates.length == 0) {
        return '暂无';
      }
      let tmpString = "";
      for(let i = 0; i < certificates.length; i++) {
        let certItem = certificates[i];
        tmpString += certItem.name;
        if (i < certificates.length - 1) {
          tmpString += ",";
        }
      }
      return tmpString;
    },

    goBackToList() {
      this.$router.go(-1);
    },
    loadData() {
      let id = this.coachId;
      let params = {
        id
      };
      let _this = this;
      this.httpManager.ajax.getCoachData(params, function (data) {
        let code = data.code;
        if (code == 0) {
          _this.item = data.data;
        } else  {
          _this.$toast("请求失败！");
        }

      }, function (data) {
        _this.$toast("请求失败！");
      })
    },
  }
}
</script>

<style scoped>

  #coach_detail_outer .referee-information-outer {
    margin-top: 50px;
    border: solid 1px #fc1a34;
    padding: 15px 15px 50px 15px;
    /*min-height: 300px;*/
    text-align: left;
  }

  .referee-information-outer .return-to-list {
    text-decoration: none;
    color: #999;
  }

  .referee-information-outer .return-to-list:hover {
    color: #fc1a34;
  }

  #coach_detail_outer .referee-information {
    margin-top: 30px;
    /*min-height: 300px;*/
    /*background-color: yellow;*/
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    justify-content: center;
    width: 100%;
  }

  .referee-information > div {
    width: 100%;
  }

  .referee-information .left-view {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-around;
    align-items: flex-start;
    padding-bottom: 15px;
  }

  .referee-information .img-view {
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .referee-information .user-image {
    width: 150px;
    height: 150px;
    background-color: white;
    /* border-radius: 75px; */
  }

  .referee-information .status-label {
    font-size: smaller;
    color: gray;
    border: solid 1px gray;
    text-align: center;
    margin-top: 10px;
    vertical-align: middle;
    padding: 2px 10px;
    width: 100px;
  }

  .referee-information .status-label.active {
    color: green;
    border: solid 1px green;
  }

  .referee-information .right-view {
    min-width: 220px;
    width: 100%;
    padding-top: 10px;

    display: flex;
    flex-direction: column;
    align-items: center;
  }


  .referee-information .sub-row-view {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    justify-content: center;
    align-items: flex-start;
    font-size: 1rem;
    color: #333;
  }

  .referee-information .nickname {
    font-size: 1.5rem;
    color: #333;
  }

  .referee-information .experience-view {
    width: 100%;
    font-size: 1rem;
    margin-top: 3px;
    color: #333;
  }

  .referee-information .sub-row-view > div {
    margin-top: 7px;
  }
  .referee-information .sub-row-view > div:first-child {
  }
  .referee-information .sub-row-view > div:not(:first-child) {
    /*width: 100%;*/
    /*background-color: red;*/
  }

  @media screen and (min-width: 768px){
    #coach_detail_outer .referee-information {
      flex-wrap: nowrap;
      justify-content: flex-start;
    }

    .referee-information .left-view {
      justify-content: flex-end;
      padding-bottom: 0px;
      width: 50%;
    }

    .referee-information .img-view {
      margin-right: 30px;
    }
    .referee-information .right-view {
      width: 50%;
      text-align: left;
      align-items: flex-start;
    }

    .referee-information .sub-row-view {
      flex-wrap: nowrap;
    }

    .referee-information .sub-row-view > div:first-child {
      /*width: 40%;*/
    }
    .referee-information .sub-row-view > div:not(:first-child) {
      /*width: 60%;*/
    }
  }


</style>



// WEBPACK FOOTER //
// src/pages/CoachDetailPage.vue